import {renderRequiredActions} from '@features/home/utils.tsx'
import {useRequiredActions} from '@features/home/queries/useRequiredActions.ts'
import {useTranslation} from '@/translations/i18n.tsx'
import {useMemo} from 'react'
import {ScrollArea, Scrollbar} from '@components/ui/scroll-area'

export const PendingActionModalContent = () => {
    const {
        t,
        i18n: {language}
    } = useTranslation()
    const useRequiredActionsQuery = useRequiredActions()
    const requiredActions = useMemo(
        () =>
            useRequiredActionsQuery.data
                ? renderRequiredActions({
                      data: useRequiredActionsQuery.data,
                      cardBorder: 'bottomBorder'
                      // showInsightsCard: meQuery.data?.isInsightsVisible
                  })
                : [],
        [useRequiredActionsQuery.isSuccess, useRequiredActionsQuery.isStale, language]
    )
    return (
        <div className="grid grid-rows-[auto_minmax(0,1fr)] grid-cols-[minmax(0,1fr)] gap-4 overflow-hidden">
            <h3 className="text-xl font-medium text-neutral-900 px-6 mt-14">
                {t('home:required_actions:x_pending_actions', {count: requiredActions.length})}
            </h3>

            <ScrollArea className="w-full px-6 pb-6" scrollbar={<Scrollbar className="mb-3" />}>
                {requiredActions}
            </ScrollArea>
        </div>
    )
}
